import { func, string, shape } from 'prop-types'

import composeWithScope from 'recompose-scope/composeWithScope'
import injectProps from 'recompose-scope/injectProps'
import exposeProps from 'recompose-scope/exposeProps'

import getContext from 'recompose/getContext'
import lifecycle from 'recompose/lifecycle'
import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'
// import withProps from 'recompose/withProps'

import loadData from './loadData'
import saveData from './saveData'
import paletteValue from './paletteValue'
import { extendDotRange, extendRectRange, extendSlashRange, extendFillRange, extendCopyRange }
  from './calcExtendRange'

import RangeEditorView from './RangeEditor'


const RangeEditor = composeWithScope(
  getContext({
    server: shape({
      get: func.isRequired,
      patch: func.isRequired,
    }).isRequired,
  }),
  injectProps({
    page: shape({
      docId: string,
    }),
  }),


  withState('scope', 'setScope', { sMax: 0, sMin: 0, cMax: 0, cMin: 0, interval: -25 }),
  withState('lastScope', 'setLastScope', { sMax: 0, sMin: 0, cMax: 0, cMin: 0, interval: -25 }),
  withHandlers({
    updateScope: ({ scope, setScope, setLastScope }) => newScope => {
      setLastScope(s => ({ ...s, ...scope }))
      setScope(s => ({ ...s, ...newScope }))
    },
  }),


  withState('ranges', 'setRanges', []),  // original name as rangesData
  withHandlers({
    updateRanges: ({ setRanges }) => (newRanges) => {
      setRanges([{ key: '0', name: '清除' }].concat(newRanges).map((rangeObj, index) => ({
        ...rangeObj,
        color: paletteValue[index],
      })))
    },
  }),


  withState('gridValues', 'setGridValues', { }),
  withState('lastGridValues', 'setLastGridValues', { }),
  withHandlers({
    updateGridValues: ({ gridValues, setGridValues, setLastGridValues }) => newGridValues => {
      setLastGridValues(gridValues)
      setGridValues(newGridValues)
    },
  }),


  withState('using', 'setUsing', { rangeKey: '0', method: 'dot', fromCell: null }),
  withHandlers({
    updateUsing: ({ using, setUsing }) => (key, value) => setUsing({ ...using, [key]: value }),
  }),


  withHandlers({
    updateScopeAndGridValues: ({ updateScope, updateGridValues, gridValues }) =>
      ({ sMax, sMin, cMax, cMin }) => {
        const newGridValues = {}
        Object.keys(gridValues).forEach(s => {
          Object.keys(gridValues[s]).forEach(c => {
            if (s <= sMax && s >= sMin && c <= cMax && c >= cMin && gridValues[s][c]) {
              if (!newGridValues[s]) {
                newGridValues[s] = {}
              }
              newGridValues[s][c] = gridValues[s][c]
            }
          })
        })
        updateGridValues(newGridValues)
        updateScope({ sMax, sMin, cMax, cMin })
      },
    extendRange: ({ using, gridValues, updateGridValues, scope, updateUsing, updateScope }) =>
    ({ fromCell, toCell, fromRange }) => {
      const { rangeKey, method } = using
      const mapMethodExtendRange = {
        dot: extendDotRange,
        rect: extendRectRange,
        slash: extendSlashRange,
        fill: extendFillRange,
        copy: extendCopyRange,
      }

      const mapKey = fromRange ? 'copy' : method
      updateGridValues(
        mapMethodExtendRange[mapKey]({ gridValues, fromCell, toCell, rangeKey, scope, fromRange })
      )
      updateScope(scope)
      updateUsing('fromCell', null)
    },
    undo: ({ updateGridValues, lastGridValues, updateScope, lastScope }) => () => {
      updateGridValues(lastGridValues)
      updateScope(lastScope)
    },
    save: ({ gridValues, ranges, scope, page: { docId }, server: { patch } }) => () =>
      saveData({ gridValues, ranges, scope, docId, patch }),
  }),

  withHandlers({
    clickCell: ({ extendRange, updateUsing, using: { method, fromCell } }) => (s, c) => {
      if (method === 'dot' || fromCell) {
        return extendRange({ fromCell, toCell: { s, c } })
      }

      return updateUsing('fromCell', { s, c })
    },
  }),


  lifecycle({
    async componentDidMount () {
      const { page: { docId }, server: { get }, updateScope, updateRanges, updateGridValues }
        = this.props
      const { product: { scope }, priceRanges } = await loadData({ docId, get })
      const { sMax = 1000, sMin = -2000, cMax = 0, cMin = -1000 } = scope || { }

      updateScope({ sMax, sMin, cMax, cMin })
      updateScope({ sMax, sMin, cMax, cMin })  // set twice to update lastScope

      updateRanges(priceRanges.map(({ _id, key }) => ({ key: _id, name: key })))

      const gridValues = { }
      priceRanges.forEach(({ _id, range = [] }) => {
        if (Array.isArray(range)) {
          range.forEach(({ s, c }) => {
            gridValues[s] = gridValues[s] || { }
            gridValues[s][c] = _id
          })
        }
      })
      updateGridValues(gridValues)
      updateGridValues(gridValues)  // set twice to update lastGridValues
    },
  }),


  exposeProps([
    'scope',
    'updateScope',
    'ranges',
    'gridValues',
    'updateGridValues',
    'extendRange',
    'undo',
    'save',
    'updateScopeAndGridValues',
    'using',
    'updateUsing',
    'clickCell',
  ]),
)(RangeEditorView)

RangeEditor.displayName = 'RangeEditor'

export default RangeEditor



// WEBPACK FOOTER //
// ./src/components/RangeEditor/index.js